"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = require("./state");
var getters_1 = require("./getters");
var actions_1 = require("./actions");
var mutations_1 = require("./mutations");
var Wizard = /** @class */ (function () {
    // create everything
    function Wizard(steps, plugins) {
        // resolve namespacing, applies "foo/bar/..." stuff automatically
        this.namespaced = true;
        this.mutations = mutations_1.default;
        this.getters = getters_1.default;
        this.actions = actions_1.default;
        this.plugins = [];
        var stepList = [
            {
                name: 'bookingPersons',
                validGetter: 'booking/persons/isValid',
                initHook: function (store) {
                    var personAmount = store.rootGetters['booking/persons/total'];
                    if (personAmount < 1) {
                        store.dispatch('booking/persons/inc', 'adults', { root: true });
                        store.dispatch('booking/persons/inc', 'adults', { root: true });
                    }
                }
            },
            {
                name: 'bookingCabinCategory',
                validGetter: 'booking/cabins/valid'
            },
            {
                name: 'bookingTransport',
                validGetter: 'booking/transport/valid'
            },
            {
                name: 'bookingPax',
                validGetter: 'booking/pax/valid'
            },
            {
                name: 'bookingInsurance',
                validGetter: 'booking/insurance/valid'
            },
            {
                name: 'bookingCheckout',
                validGetter: 'booking/checkout/valid'
            }
        ];
        if (!steps) {
            steps = stepList;
        }
        this.state = new state_1.WizardState(steps);
        this.plugins = plugins;
    }
    return Wizard;
}());
exports.Wizard = Wizard;
//# sourceMappingURL=index.js.map